import styled from '@emotion/styled'
import { AiOutlineClose, AiOutlineUp } from 'react-icons/ai'
import { useHistory } from 'react-router'
import TitleHeader from '../../../components/app-layout/AppHeader/TitleHeader'
import Breadcrumb from '../../../components/common/Breadcrumb'
import Button from '../../../components/common/Button'
import Text from '../../../components/common/Text'
import { SHOP_PRIMARY, WHITE } from '../../../constant/colors'
import * as paths from '../../../constant/path'
import { shop, productDetail } from '../../../constant/path'
import { useAddProductToCart } from '../../../services/cart/cart-query'
import { useGetProductDetail } from '../../../services/shop/shop-query'
import { useRouter } from '../../../utils/helper'
import { mobile, useScreen } from '../../../utils/responsive-helper'
import AddCartFooter from '../components/AddCartFooter'
import ProductDesciptionCard from '../components/ProductDesciptionCard'

const Layout = styled.div`
  margin-top: 20px;

  ${mobile} {
    margin-top: 0px;
  }
`

const ProductDesciptionLayout = styled.div`
  width: 100%;
  background-color: ${WHITE};
  margin: 16px 0;
  padding: 16px;

  ${mobile} {
    width: 100vw;
    margin: 64px -16px 98px -16px;
    padding: 16px;
  }
`

const ButtonStyled = styled(Button)`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`

const ProductDetailDescription = () => {
  const history = useHistory()
  const { productId } = useRouter().query
  const { isMobile } = useScreen()
  const { data: productDetailData } = useGetProductDetail(productId)
  const { mutate: addProductToCart } = useAddProductToCart()

  const handleProductDetailNavigation = () => {
    history.push(
      paths.productDetail({
        routeParam: {
          productId,
        },
        queryParam: {
          page: paths.shop(),
        },
      }),
    )
  }

  const handleAddProductInCart = (e: any) => {
    addProductToCart({
      productId,
      quantity: 1,
    })
    e.stopPropagation()
  }

  return (
    <Layout>
      {isMobile ? (
        <TitleHeader
          title={productDetailData?.title || ''}
          icon={<AiOutlineClose />}
          path={paths.productDetail({
            routeParam: {
              productId,
            },
            queryParam: {
              page: paths.shop(),
            },
          })}
        />
      ) : (
        <Breadcrumb
          overide={(paths) => {
            paths[0] = {
              label: 'หน้าสินค้า',
              path: shop(),
            }
            paths[1] = {
              label: 'category',
              path: shop(),
            }
            paths[2] = {
              label: productDetailData?.title || '',
              path: productDetail({
                routeParam: {
                  productId,
                },
                queryParam: {
                  page: shop(),
                },
              }),
            }
            paths[3] = {
              label: 'รายละเอียดสินค้า',
              path: shop(),
            }
            return paths
          }}
        />
      )}
      <ProductDesciptionLayout>
        <ProductDesciptionCard
          description={`Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
        been the industry's standard dummy text ever since the 1500s, when an unknown printer took
        a galley of type and scrambled it to make a type specimen book. It has survived not only
        five centuries, but also the leap into electronic typesetting, remaining essentially
        unchanged. It was popularised in the 1960s with the release of Letraset sheets containing`}
        />
        {isMobile && (
          <ButtonStyled
            fontColor={SHOP_PRIMARY}
            style={{
              width: '100%',
              maxWidth: '100%',
              background: 'transparent',
              marginRight: 8,
              borderColor: 'transparent',
            }}
          >
            <Text
              color={SHOP_PRIMARY}
              type="SemiBold"
              onClick={handleProductDetailNavigation}
              style={{ paddingRight: 4 }}
            >
              ดูน้อยลง
            </Text>
            <AiOutlineUp />
          </ButtonStyled>
        )}
      </ProductDesciptionLayout>
      {isMobile && (
        <AddCartFooter
          content="ราคาสินค้า"
          textButton="เพิ่มลงในตะกร้า"
          value={1234}
          onClick={(e) => handleAddProductInCart(e)}
        />
      )}
    </Layout>
  )
}

export default ProductDetailDescription
